import { IDeleteCronogramaSGQUseCase } from "../../../presentation/useCases/delete/delete_cronogramaSGQ_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteCronogramaSGQUseCase


export class DeleteCronogramaSGQUseCase implements IDeleteCronogramaSGQUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteCronogramaSGQ( IdCronogramaSGQ: number): Promise<void> {
    
    await this.repository.deleteCronogramaSGQ( IdCronogramaSGQ );
  }
}
